import firebase from 'firebase/app';
import 'firebase/firestore';

const  config = {
    apiKey: "AIzaSyAATT3-uId8lYyemFiCOXbzHd0wLqnuAY8",
    authDomain: "business-manager-fb.firebaseapp.com",
    databaseURL: "https://business-manager-fb.firebaseio.com",
    projectId: "business-manager-fb",
    storageBucket: "business-manager-fb.appspot.com",
    messagingSenderId: "871622430546"
};

firebase.initializeApp(config);
firebase.firestore().settings({timestampsInSnapshots: true});

export default firebase.firestore();